(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 2748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9473);
/* harmony import */ var _helpers_functions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6675);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5893);










const Header = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(() => Promise.all(/* import() */[__webpack_require__.e(4838), __webpack_require__.e(3219), __webpack_require__.e(7444), __webpack_require__.e(5580), __webpack_require__.e(8967)]).then(__webpack_require__.bind(__webpack_require__, 5320)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(5320)]
  }
});
const Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(() => Promise.all(/* import() */[__webpack_require__.e(4838), __webpack_require__.e(4396), __webpack_require__.e(7444), __webpack_require__.e(5580), __webpack_require__.e(6079), __webpack_require__.e(2945)]).then(__webpack_require__.bind(__webpack_require__, 6079)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(6079)]
  }
});
const HeroSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(() => Promise.all(/* import() */[__webpack_require__.e(7473), __webpack_require__.e(7444), __webpack_require__.e(3839)]).then(__webpack_require__.bind(__webpack_require__, 337)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(337)]
  }
});
const AboutSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(() => Promise.all(/* import() */[__webpack_require__.e(7444), __webpack_require__.e(1874)]).then(__webpack_require__.bind(__webpack_require__, 1874)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(1874)]
  }
});
const ServicesSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(() => Promise.all(/* import() */[__webpack_require__.e(7473), __webpack_require__.e(8802), __webpack_require__.e(7444), __webpack_require__.e(2873), __webpack_require__.e(990), __webpack_require__.e(1559)]).then(__webpack_require__.bind(__webpack_require__, 1479)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(1479)]
  }
});
const HowWeWorkSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(() => Promise.all(/* import() */[__webpack_require__.e(7473), __webpack_require__.e(7444), __webpack_require__.e(4076), __webpack_require__.e(503)]).then(__webpack_require__.bind(__webpack_require__, 5270)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(5270)]
  }
});
const WorksSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(() => Promise.all(/* import() */[__webpack_require__.e(7473), __webpack_require__.e(7444), __webpack_require__.e(2873), __webpack_require__.e(5149)]).then(__webpack_require__.bind(__webpack_require__, 3469)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(3469)]
  }
});
const SubscribeSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(() => Promise.all(/* import() */[__webpack_require__.e(3053), __webpack_require__.e(649)]).then(__webpack_require__.bind(__webpack_require__, 649)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(649)]
  }
});
const ClientsSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(() => Promise.all(/* import() */[__webpack_require__.e(7473), __webpack_require__.e(7444), __webpack_require__.e(2873), __webpack_require__.e(1681)]).then(__webpack_require__.bind(__webpack_require__, 909)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(909)]
  }
});
const VrSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(() => Promise.all(/* import() */[__webpack_require__.e(8802), __webpack_require__.e(7444), __webpack_require__.e(990), __webpack_require__.e(3967), __webpack_require__.e(6299)]).then(__webpack_require__.bind(__webpack_require__, 952)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(952)]
  }
});
const ProfileDownloadSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(() => Promise.all(/* import() */[__webpack_require__.e(7444), __webpack_require__.e(1663)]).then(__webpack_require__.bind(__webpack_require__, 1663)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(1663)]
  }
});

const LazyMount = _ref => {
  let {
    enabled,
    children,
    minHeight = 0
  } = _ref;
  const holderRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const {
    0: isMounted,
    1: setIsMounted
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!enabled);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!enabled) {
      setIsMounted(true);
      return;
    }

    if (false) {}
    const node = holderRef.current;
    if (!node) return;

    if (!("IntersectionObserver" in window)) {
      setIsMounted(true);
      return;
    }

    let active = true;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        if (active) setIsMounted(true);
        observer.disconnect();
      }
    }, {
      rootMargin: "300px 0px"
    });
    observer.observe(node);
    return () => {
      active = false;
      observer.disconnect();
    };
  }, [enabled]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    ref: holderRef,
    style: !isMounted && minHeight ? {
      minHeight
    } : {},
    children: isMounted ? children : null
  });
};

const businessSchemaByLocale = {
  ar: {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "@id": "https://designconcepts.sa/#business-ar",
    name: "مفاهيم التصميم",
    alternateName: "Design Concepts",
    url: "https://designconcepts.sa/",
    logo: "https://desginconcept.ejjadh.info/uploads/file-1767958980593.png",
    image: "https://desginconcept.ejjadh.info/uploads/file-1767958980593.png",
    telephone: "+966541302695",
    email: "info@designconcepts.sa",
    address: {
      "@type": "PostalAddress",
      addressLocality: "الرياض",
      addressCountry: "SA"
    },
    areaServed: {
      "@type": "Country",
      name: "Saudi Arabia"
    },
    sameAs: ["https://www.facebook.com/designconcepts001", "https://x.com/d_c_sa", "https://www.instagram.com/d_c_sa/", "https://www.snapchat.com/@designcon2016", "https://www.tiktok.com/@d_c_sa", "https://maps.app.goo.gl/vSVLBkVYeBKecNEQA"],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "الخدمات",
      itemListElement: [{
        "@type": "Service",
        name: "لوحة جمع الافكار",
        url: "https://designconcepts.sa/services/Idea-collection-board"
      }, {
        "@type": "Service",
        name: "الإشراف الهندسي على المواقع",
        url: "https://designconcepts.sa/services/Engineering-supervision-of-sites"
      }, {
        "@type": "Service",
        name: "مخططات تنفيذية تفصيلية",
        url: "https://designconcepts.sa/services/Detailed-implementation-plans"
      }, {
        "@type": "Service",
        name: "مناظير خارجية وداخلية ثلاثية الأبعاد",
        url: "https://designconcepts.sa/services/3D-external-and-internal-viewfinders"
      }, {
        "@type": "Service",
        name: "أعمال مخططات الكهرباء والسباكة",
        url: "https://designconcepts.sa/services/Electrical-and-Plumbing-Drawings"
      }, {
        "@type": "Service",
        name: "الرفع المساحي للموقع",
        url: "https://designconcepts.sa/services/Site-surveying"
      }, {
        "@type": "Service",
        name: "تنسيق وتوريد الأثاث",
        url: "https://designconcepts.sa/services/Furniture-Coordination-and-Supply"
      }]
    }
  },
  en: {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "@id": "https://designconcepts.sa/#business-en",
    name: "Design Concepts",
    alternateName: "مفاهيم التصميم",
    url: "https://designconcepts.sa/en",
    logo: "https://desginconcept.ejjadh.info/uploads/file-1767958980593.png",
    image: "https://desginconcept.ejjadh.info/uploads/file-1767958980593.png",
    telephone: "+966541302695",
    email: "info@designconcepts.sa",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Riyadh",
      addressCountry: "SA"
    },
    areaServed: {
      "@type": "Country",
      name: "Saudi Arabia"
    },
    sameAs: ["https://www.facebook.com/designconcepts001", "https://x.com/d_c_sa", "https://www.instagram.com/d_c_sa/", "https://www.snapchat.com/@designcon2016", "https://www.tiktok.com/@d_c_sa", "https://maps.app.goo.gl/vSVLBkVYeBKecNEQA"],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Services",
      itemListElement: [{
        "@type": "Service",
        name: "Idea collection board",
        url: "https://designconcepts.sa/en/services/Idea-collection-board"
      }, {
        "@type": "Service",
        name: "Engineering Site Supervision",
        url: "https://designconcepts.sa/en/services/Engineering-supervision-of-sites"
      }, {
        "@type": "Service",
        name: "Detailed implementation plans",
        url: "https://designconcepts.sa/en/services/Detailed-implementation-plans"
      }, {
        "@type": "Service",
        name: "3D Exterior and Interior Renderings",
        url: "https://designconcepts.sa/en/services/3D-external-and-internal-viewfinders"
      }, {
        "@type": "Service",
        name: "Electrical and Plumbing Drawings",
        url: "https://designconcepts.sa/en/services/Electrical-and-Plumbing-Drawings"
      }, {
        "@type": "Service",
        name: "Site Surveying",
        url: "https://designconcepts.sa/en/services/Site-surveying"
      }, {
        "@type": "Service",
        name: "Furniture Coordination & Supply",
        url: "https://designconcepts.sa/en/services/Furniture-Coordination-and-Supply"
      }]
    }
  }
};
const faqSchemaByLocale = {
  ar: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    inLanguage: "ar",
    mainEntity: [{
      "@type": "Question",
      name: "ماذا سأستلم عند التصميم؟",
      acceptedAnswer: {
        "@type": "Answer",
        text: "ملف تصميم ويشمل رسومات الثري دي والمخططات التفصيلية بالإضافة إلى جداول كميات مواد التشطيب"
      }
    }, {
      "@type": "Question",
      name: "هل يتم توفير الأثاث؟",
      acceptedAnswer: {
        "@type": "Answer",
        text: "نعم يتم توفير وتوريد الأثاث جاهز وتفصيل حسب المعتمد في التصميم"
      }
    }, {
      "@type": "Question",
      name: "كم مدة العمل على التصميم؟",
      acceptedAnswer: {
        "@type": "Answer",
        text: "مدة العمل على التصميم تعتمد على تفاصيل التصميم المطلوبة بناء على ما يناسب الموقع"
      }
    }, {
      "@type": "Question",
      name: "كم مدة العمل على التنفيذ؟",
      acceptedAnswer: {
        "@type": "Answer",
        text: "مدة أعمال التنفيذ تعتمد بشكل كبير على أعمال التصميم، بعد اعتماد التصميم الداخلي يتم تحديد مدة تنفيذ مشروعك."
      }
    }, {
      "@type": "Question",
      name: "كم سعر التنفيذ؟",
      acceptedAnswer: {
        "@type": "Answer",
        text: "يتم تحديد تكلفة التنفيذ بعد اعتماد التصاميم، مع العلم أن تسعيرة التصميم منفصلة تمامًا عن تسعيرة التنفيذ."
      }
    }]
  },
  en: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    inLanguage: "en",
    mainEntity: [{
      "@type": "Question",
      name: "What will I receive upon design?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "A design file that includes 3D drawings, detailed plans, and bills of quantities for finishing materials."
      }
    }, {
      "@type": "Question",
      name: "Is furniture provided?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes, furniture is supplied ready-made and custom-made according to the approved design."
      }
    }, {
      "@type": "Question",
      name: "How long does it take to work on the design?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "The design work time depends on the required design details and what suits the site."
      }
    }, {
      "@type": "Question",
      name: "How long will the implementation process take?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "The duration of the execution works depends largely on the design works. After the interior design is approved, the duration of your project is determined."
      }
    }, {
      "@type": "Question",
      name: "What is the cost of execution?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "The cost of implementation is determined after the designs are approved, noting that the design pricing is completely separate from the implementation pricing."
      }
    }]
  }
};

const Home = () => {
  var _sectionData$metaTitl, _settings$appName, _sectionData$metaDesc, _sectionData$metaTitl2, _sectionData$metaDesc2, _sectionData$metaTitl3, _sectionData$metaDesc3;

  const {
    locale
  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
  const {
    sectionData,
    settings
  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(state => state.settings);
  const slidesWrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const {
    0: canInitScrollEffects,
    1: setCanInitScrollEffects
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const {
    0: isMobile,
    1: setIsMobile
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (false) {}
    const mediaQuery = window.matchMedia("(max-width: 1023px)");

    const updateMobileState = () => setIsMobile(mediaQuery.matches);

    updateMobileState();
    mediaQuery.addEventListener("change", updateMobileState);
    return () => {
      mediaQuery.removeEventListener("change", updateMobileState);
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (false) {}
    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!isDesktop || prefersReducedMotion) return;
    let enabled = false;

    const enableEffects = () => {
      if (enabled) return;
      enabled = true;
      setCanInitScrollEffects(true);
      window.removeEventListener("scroll", enableEffects);
      window.removeEventListener("wheel", enableEffects);
      window.removeEventListener("touchmove", enableEffects);
    };

    window.addEventListener("scroll", enableEffects, {
      passive: true
    });
    window.addEventListener("wheel", enableEffects, {
      passive: true
    });
    window.addEventListener("touchmove", enableEffects, {
      passive: true
    });
    return () => {
      window.removeEventListener("scroll", enableEffects);
      window.removeEventListener("wheel", enableEffects);
      window.removeEventListener("touchmove", enableEffects);
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (false) {}
    if (!slidesWrapperRef.current) return;
    if (!canInitScrollEffects) return;
    let cancelled = false;

    let cleanup = () => {};

    const initScrollAnimations = async () => {
      const [{
        default: gsap
      }, {
        default: ScrollTrigger
      }] = await Promise.all([Promise.all(/* import() */[__webpack_require__.e(8802), __webpack_require__.e(990)]).then(__webpack_require__.bind(__webpack_require__, 990)), __webpack_require__.e(/* import() */ 6546).then(__webpack_require__.t.bind(__webpack_require__, 6546, 23))]);
      if (cancelled || !slidesWrapperRef.current) return;
      gsap.registerPlugin(ScrollTrigger);
      const panels = gsap.utils.toArray(slidesWrapperRef.current.querySelectorAll(".section"));
      panels.pop();
      const windowHeight = window.innerHeight;
      const measuredPanels = panels.map(panel => {
        const innerpanel = panel.querySelector(".section-inner");
        if (!innerpanel) return null;
        const panelHeight = innerpanel.offsetHeight;
        const difference = panelHeight - windowHeight;
        const fakeScrollRatio = difference > 0 ? difference / (difference + windowHeight) : 0;
        return {
          panel,
          innerpanel,
          panelHeight,
          fakeScrollRatio,
          endValue: fakeScrollRatio ? `+=${panelHeight}` : "bottom top"
        };
      }).filter(Boolean);
      measuredPanels.forEach(_ref2 => {
        let {
          panel,
          innerpanel,
          panelHeight,
          fakeScrollRatio,
          endValue
        } = _ref2;
        const shouldApplyFakeScroll = fakeScrollRatio && !panel.classList.contains("section-4");

        if (shouldApplyFakeScroll) {
          panel.style.marginBottom = panelHeight * fakeScrollRatio + "px";
        }

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: panel,
            start: "bottom bottom",
            end: endValue,
            pinSpacing: false,
            pin: true,
            scrub: true
          }
        });

        if (shouldApplyFakeScroll) {
          tl.to(innerpanel, {
            yPercent: -100,
            y: windowHeight,
            duration: 1 / (1 - fakeScrollRatio) - 1,
            ease: "none"
          });
        }

        tl.fromTo(panel, {
          scale: 1,
          opacity: 1
        }, {
          scale: 0.7,
          opacity: 0.5,
          duration: 0.9
        }).to(panel, {
          opacity: 0,
          duration: 0.1
        });
      });

      cleanup = () => {
        ScrollTrigger.getAll().forEach(trigger => trigger.kill());
      };
    };

    if (window.requestIdleCallback) {
      window.requestIdleCallback(initScrollAnimations, {
        timeout: 1500
      });
    } else {
      setTimeout(initScrollAnimations, 300);
    }

    return () => {
      cancelled = true;
      cleanup();
    };
  }, [canInitScrollEffects]);
  const businessSchema = locale === "en" ? businessSchemaByLocale.en : businessSchemaByLocale.ar;
  const faqSchema = locale === "en" ? faqSchemaByLocale.en : faqSchemaByLocale.ar;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify(businessSchema)
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify(faqSchema)
        }
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
      title: `${sectionData === null || sectionData === void 0 ? void 0 : (_sectionData$metaTitl = sectionData.metaTitle) === null || _sectionData$metaTitl === void 0 ? void 0 : _sectionData$metaTitl[locale]} | ${settings === null || settings === void 0 ? void 0 : (_settings$appName = settings.appName) === null || _settings$appName === void 0 ? void 0 : _settings$appName[locale]}`,
      description: sectionData === null || sectionData === void 0 ? void 0 : (_sectionData$metaDesc = sectionData.metaDescription) === null || _sectionData$metaDesc === void 0 ? void 0 : _sectionData$metaDesc[locale],
      openGraph: {
        title: sectionData === null || sectionData === void 0 ? void 0 : (_sectionData$metaTitl2 = sectionData.metaTitle) === null || _sectionData$metaTitl2 === void 0 ? void 0 : _sectionData$metaTitl2[locale],
        description: sectionData === null || sectionData === void 0 ? void 0 : (_sectionData$metaDesc2 = sectionData.metaDescription) === null || _sectionData$metaDesc2 === void 0 ? void 0 : _sectionData$metaDesc2[locale]
      } // canonical={
      //   typeof window !== "undefined"
      //     ? window.location.href
      //     : `${process.env.NEXT_PUBLIC_SITE_URL}/${asPath}`
      // }
      ,
      twitter: {
        cardType: "summary_large_image",
        handle: "@handle",
        site: "@site",
        title: sectionData === null || sectionData === void 0 ? void 0 : (_sectionData$metaTitl3 = sectionData.metaTitle) === null || _sectionData$metaTitl3 === void 0 ? void 0 : _sectionData$metaTitl3[locale],
        description: sectionData === null || sectionData === void 0 ? void 0 : (_sectionData$metaDesc3 = sectionData.metaDescription) === null || _sectionData$metaDesc3 === void 0 ? void 0 : _sectionData$metaDesc3[locale],
        image: (0,_helpers_functions__WEBPACK_IMPORTED_MODULE_7__/* .handleImageLink */ .Iz)(settings === null || settings === void 0 ? void 0 : settings.appLogo)
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Header, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("main", {
      className: "slides-wrapper",
      ref: slidesWrapperRef,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("section", {
        className: "section section-1",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "section-content",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "section-inner",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(HeroSection, {})
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("section", {
        className: "section section-2",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "section-content",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "section-inner",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(AboutSection, {})
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("section", {
        className: "section section-3",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "section-content",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "section-inner",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(LazyMount, {
              enabled: isMobile,
              minHeight: 500,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(ServicesSection, {})
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("section", {
        className: "section section-4",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "section-content",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "section-inner",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(LazyMount, {
              enabled: isMobile,
              minHeight: 420,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(HowWeWorkSection, {})
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("section", {
        className: "section section-5",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "section-content",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "section-inner",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(LazyMount, {
              enabled: isMobile,
              minHeight: 520,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(WorksSection, {})
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("section", {
        className: "section section-6",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "section-content",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "section-inner",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(LazyMount, {
              enabled: isMobile,
              minHeight: 420,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(VrSection, {})
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("section", {
        className: "section section-7",
        style: {
          backgroundColor: "#e4d5be54"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "section-content",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "section-inner",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(LazyMount, {
              enabled: isMobile,
              minHeight: 420,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(ProfileDownloadSection, {})
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("section", {
        className: "section section-8",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "section-content",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "section-inner",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(LazyMount, {
              enabled: isMobile,
              minHeight: 700,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(SubscribeSection, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(ClientsSection, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Footer, {})]
              })
            })
          })
        })
      })]
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Home);

/***/ }),

/***/ 6675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iz": function() { return /* binding */ handleImageLink; },
/* harmony export */   "Yi": function() { return /* binding */ getDataBySlug; },
/* harmony export */   "xE": function() { return /* binding */ getFullDate; }
/* harmony export */ });
/* unused harmony exports getId, getTime */
// get the numeric date
const getFullDate = (date, locale) => {
  if (!date) return;
  return new Date(date).toLocaleDateString(locale === "ar" ? "ar-EG" : "en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
}; //handle the image link if it is not a full link then add the base url

const handleImageLink = image => {
  if (image !== null && image !== void 0 && image.includes("http")) {
    return image;
  } else {
    // eslint-disable-next-line no-undef
    return `${"https://desginconcept.ejjadh.info"}/${image}`;
  }
};
const getId = obj => (obj === null || obj === void 0 ? void 0 : obj._id) || (obj === null || obj === void 0 ? void 0 : obj.id); // get time in arabic from timestamp

const getTime = (timestamp, locale) => {
  if (!timestamp) return;
  return new Date(timestamp).toLocaleTimeString(locale === "ar" ? "ar-EG" : "en-US", {
    hour: "numeric",
    minute: "numeric"
  });
}; // get data depend on slug

const getDataBySlug = (data, slug) => {
  return data === null || data === void 0 ? void 0 : data.find(item => item.slug === slug);
};

/***/ }),

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2748);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,9774,2888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);